window.MoMA = window.MoMA || {};

const offsetScrollDistance = (el) => {
  return distanceFromTop(el) - navHeight();
}

const distanceFromTop = (el) => {
  const distanceScrolled = window.pageYOffset || document.documentElement.scrollTop;
  return el.getBoundingClientRect().y + distanceScrolled;
}

const navHeight = () => {
  const headerNav = document.querySelector('.header__nav');
  if (!headerNav) return 0;

  return headerNav.offsetHeight;
}

const currentRefreshedNavHeight = () => {
  const headerNav = document.querySelector('[data-main-navigation]');
  const headerNavHeight = headerNav.getBoundingClientRect().height + headerNav.getBoundingClientRect().top;
  return headerNavHeight;
}

window.MoMA.scrollTo = function (el) {
  window.scrollTo(0, offsetScrollDistance(el));
}

export { offsetScrollDistance, distanceFromTop, currentRefreshedNavHeight };
